import { useState, useRef } from 'react';

import { Box } from '@mui/material';

import { Header } from '@/types/generated';
import { Maybe } from '@/types';
import { useFacilityContext } from '@/context';

import SchedulingButton from '../SchedulingButton/SchedulingButton';

import LocationSearch from './LocationSearch/LocationSearch';
import { getLocationNavigationBarStyles, searchWrapStyles } from './LocationNavBar.styles';
import LocationDetails from './LocationDetails/LocationDetails';
import LocationNavMenu from './LocationNavMenu/LocationNavMenu';

interface ILocationNavBar {
	schedulingButtonText?: Maybe<string>;
	schedulingButtonTextMobile?: Maybe<string>;
	locationBarFindOfficeUrl?: Header['locationBarFindOfficeUrl'];
	schedulingButtonUrl?: Header['schedulingButtonUrl'];
	isMobile?: boolean;
	searchFieldTitle?: Maybe<string>;
}

export default function LocationNavBar({
	schedulingButtonText,
	locationBarFindOfficeUrl,
	schedulingButtonTextMobile,
	isMobile,
	searchFieldTitle,
	schedulingButtonUrl,
}: Readonly<ILocationNavBar>) {
	const { officeInfo } = useFacilityContext();
	const [searchOpened, setSearchOpened] = useState(false);
	const locationNavBarRef = useRef<HTMLDivElement>(null);
	const schedulingButtonUrlFinal = officeInfo?.scheduling?.schedulingUrl || schedulingButtonUrl;

	return (
		<Box
			data-testid="location_navigation_bar"
			sx={getLocationNavigationBarStyles(isMobile)}
			ref={locationNavBarRef}
		>
			<Box sx={searchWrapStyles}>
				{officeInfo && !searchOpened ? (
					<LocationDetails
						setSearchOpened={setSearchOpened}
						isMobile={isMobile}
						locationNavBarRef={locationNavBarRef}
					/>
				) : (
					<LocationSearch
						locationBarFindOfficeUrl={locationBarFindOfficeUrl}
						isMobile={isMobile}
						locationNavBarRef={locationNavBarRef}
						searchOpened={searchOpened}
						searchFieldTitle={searchFieldTitle}
					/>
				)}
				{!isMobile && <LocationNavMenu />}
			</Box>
			<SchedulingButton
				schedulingButtonUrl={schedulingButtonUrlFinal}
				schedulingButtonText={schedulingButtonText}
				schedulingButtonTextMobile={schedulingButtonTextMobile}
				isMobile={isMobile}
			/>
		</Box>
	);
}
